import BaseActionCreator from "actions/BaseActionCreator";
import Events from "actions/events";
import { ADMIN_ORIGIN, ADMIN_USER_SETTING_PREFIX } from './config';

class SettingsActionCreator extends BaseActionCreator {
	saveProductionPreferences (productionId, clientId) {
		let url = `${ADMIN_USER_SETTING_PREFIX}?name=seriesDefault&value=${productionId}&key=clientId`;
		return this.get(ADMIN_ORIGIN, url).then((data) => {
	    	this.dispatch({type: Events.Settings.PRODUCTION_DEFAULT_RECEIVE, data: data.result})
	    });
	}
	saveTabPreferences (graphDefault, clientId) {
		let url = `${ADMIN_USER_SETTING_PREFIX}?name=graphDefault&value=${graphDefault}&key=userId`;
		return this.get(ADMIN_ORIGIN, url).then((data) => {
	    	this.dispatch({type: Events.Settings.TAB_DEFAULT_RECEIVE, data: data.result})
	    });
	}
	getProductionPreferences () {
		let url = `${ADMIN_USER_SETTING_PREFIX}?name=seriesDefault&key=clientId`;
		return this.get(ADMIN_ORIGIN, url).then((data) => {
			if(data.result) {
				this.dispatch({type: Events.Settings.PRODUCTION_DEFAULT_RECEIVE, data: data.result})
				return data.result;
			}
	    });
	}
	getTabPreferences() {
		let url = `${ADMIN_USER_SETTING_PREFIX}?name=graphDefault&key=userId`;
		return this.get(ADMIN_ORIGIN, url).then((data) => {
			if(data.result) {
				this.dispatch({type: Events.Settings.TAB_DEFAULT_RECEIVE, data: data.result})
				return data.result;
			}
	    });
	}

}
export default new SettingsActionCreator();



// WEBPACK FOOTER //
// ./src/actions/SettingsActionCreator.js